// src/modules/app-views/_apps/appmulti/receivables/pages/Init/components/tableColumns/billingTypeColumn.js
import translateX from 'utils/translateX';

function billingTypeColumn(buildColumnProps, options = {}) {
  const {
    key = 'billingType',
    title = 'payment_method',
    dataIndex = 'billingType',
    width = 150,
    columnProps = { sort: true },
  } = options;

  return {
    key,
    title: translateX(title),
    dataIndex,
    ...(width && { width }),
    ...buildColumnProps(dataIndex, columnProps),
    render: value => {
      if (!value) return <span className="text-muted">—</span>;
      const label = value === 'whatever' ? 'all_payments_title' : value;
      return translateX(label);
    },
  };
}

export default billingTypeColumn;
